module.exports = __webpack_public_path__ + "img/adsense_logo.ba125602.png";